import React from "react";
import Grid from "@mui/material/Grid";
import StorefrontIcon from "@mui/icons-material/Storefront";
import Card from "@mui/material/Card";
import CardMedia from '@mui/material/CardMedia';
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { useHistory } from "react-router-dom";

export default function DetailTemplateConnectedSuppliers(props: any) {
    const history = useHistory();
    return (
        <Grid container xs={12} columns={{ xs: 4, sm: 8, md: 12 }}
            className="suppliersListDetailContent"
            style={{ alignSelf: 'center' }}>
            <span className="financialListDetailTitle" >
                {props.title}
            </span>
            <Grid container xs={12} columns={{ xs: 4, sm: 8, md: 12 }} style={{ alignSelf: 'center', paddingTop: '27px' }}>
                {props.data?.length > 0 ?
                    props.data?.map((item: any) => (
                        <Grid xs={2}
                            md={2}
                            sm={3}
                            style={{ textAlign: 'center', alignItems: 'center' }}
                            // borderBottom={{ xs: "1px solid #c1c7cb", md: "none" }}
                            paddingX={".5rem"}
                            paddingY={{
                                xs: "1rem",
                                sm: "1rem",
                                md: "1rem",
                                lg: "0",
                                xl: "0",
                            }}
                        >
                            {item.logo ?
                                <Card sx={{ maxWidth: 345, boxShadow: 'none !important', border: '0px !important', cursor: 'pointer' }}
                                    onClick={() => {
                                        history.push({
                                            pathname: "/SuppliersList1/SuppliersListDetail",
                                            state: { id: item.supplierId },
                                        });
                                        localStorage.setItem(
                                            "SUPPLIER_ID",
                                            JSON.stringify(item.supplierId)
                                        );
                                    }}
                                >
                                    <CardMedia
                                        style={{ width: '80px', objectFit: 'none', textAlign: 'center', display: 'inline', marginRight: '10px' }}
                                        className="suppliersCardImg"
                                        component="img"
                                        // height="194"
                                        image={`data:image/png;base64,${item?.logo}`}
                                        alt="Paella dish"
                                    />
                                    <CardContent>
                                        <Typography variant="body2" color="text.secondary" className="colorTitle textFont16">
                                            {item.title}
                                        </Typography>
                                    </CardContent>
                                    {/* <img
                                    className="suppliersCardImg"
                                    src={`data:image/png;base64,${item?.logo}`}
                                    alt=""
                                /> */}
                                </Card>
                                :
                                <Card sx={{ maxWidth: 345, boxShadow: 'none !important', border: '0px !important', cursor: 'pointer' }}
                                    onClick={() => {
                                        history.push({
                                            pathname: "/SuppliersList1/SuppliersListDetail",
                                            state: { id: item.supplierId },
                                        });
                                        localStorage.setItem(
                                            "SUPPLIER_ID",
                                            JSON.stringify(item.supplierId)
                                        );
                                    }}
                                >
                                    <StorefrontIcon
                                        style={{
                                            width: "75px",
                                            height: "75px",
                                            color: "#9a9e9e",
                                            padding: "15px",
                                        }}
                                        className="suppliersCardImg"
                                    />
                                    <CardContent>
                                        <Typography variant="body2" color="text.secondary" className="colorTitle textFont16">
                                            {item.title}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            }

                        </Grid>
                    ))
                    : ""
                }


            </Grid>
        </Grid>
    )
}